export const SERVICE_URL = process.env.REACT_APP_URL_BK;
